import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is this eBook beginner-friendly?",
      answer: "Absolutely! Each strategy is explained step-by-step with real examples. Whether you're just starting or looking to scale, you'll find actionable tactics that work for your level."
    },
    {
      question: "Will it work for my business?",
      answer: "Yes! These strategies work for any business - online, offline, B2B, B2C, services, products. The principles are universal and can be adapted to any industry or business model."
    },
    {
      question: "How do I access my bonuses?",
      answer: "All bonuses are delivered instantly to your email after purchase. You'll get download links for the eBook, workshop access, templates, and software login details within 5 minutes."
    },
    {
      question: "Can I automate WhatsApp safely?",
      answer: "Yes! Our methods are 100% WhatsApp-compliant. We teach you safe automation techniques that won't get your number banned. Plus, you get access to approved tools and best practices."
    },
    {
      question: "What if I'm not tech-savvy?",
      answer: "No worries! Everything is explained in simple terms with video tutorials. Most strategies can be implemented without any technical knowledge. We provide ready-to-use templates and step-by-step guides."
    },
    {
      question: "What tools are included?",
      answer: "You get free access to CRM software, email automation tools, WhatsApp business tools, lead generation software, and analytics dashboards - worth ₹5,999 alone!"
    },
    {
      question: "Is there a refund or support policy?",
      answer: "We offer a 7-Day Action Guarantee. Try any 5 strategies from the eBook. If you don't see results or need help implementing them, we'll provide personal assistance or a full refund."
    }
  ];

  return (
    <section id="faq" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Frequently Asked <span className="gradient-text">Questions</span> ❓
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to know before you get started
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl shadow-lg mb-4 overflow-hidden"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <button
                className="w-full p-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="font-semibold text-lg text-gray-800 pr-4">{faq.question}</h3>
                <SafeIcon 
                  icon={openIndex === index ? FiChevronUp : FiChevronDown} 
                  className="w-5 h-5 text-gray-600 flex-shrink-0" 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;